import {writable, get} from 'svelte/store';
import internalApi from 'Utility/internalApi';
import {loading} from 'Store/investorProfile/loadingStore';
import {dealId} from 'Store/investorProfile/dealIdStore';
import {investorId} from 'Store/investorProfile/investorIdStore';

const createSelectedProfileIdStore = () => {
  const selectedProfileId = writable<number>(undefined);
  const {set, subscribe} = selectedProfileId;

  return {
    set,
    subscribe,
    updateProfile: async (profileId: number): Promise<void> => {
      const response: Response = await internalApi.patch(
        `deals/${get(dealId)}/investors/${get(investorId)}`,
        {
          body: JSON.stringify({investor_profile_id: profileId}),
          headers: {'Content-Type': 'application/json'},
        }
      );

      if (response?.ok) {
        set(profileId);
        window.location.href = './resume?initiated=true';
      } else {
        loading.set(false);
        throw new Error('Server Error');
      }
    },
  };
};

export const selectedProfileId = createSelectedProfileIdStore();
